import { Component } from '@angular/core';
import { SidenavComponent } from './navigation/sidenav/sidenav.component';
import { ToolbarComponent } from './navigation/toolbar/toolbar.component';

@Component({
    selector: 'fw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [ToolbarComponent, SidenavComponent]
})
export class AppComponent {

  public sidenavOpen: boolean;
  title = 'fw';
}
